import {
  SequencePayload,
  sequenceSlugByType,
  SequenceTypesIds,
  TravelProposal,
} from 'types';
import {
  apiDeleteRequest,
  apiPostRequest,
  apiPutRequest,
} from 'utilities/http/api/apiHttp';

export const apiSequence = {
  createSequence: (
    travelId: number,
    travelSequenceType: SequenceTypesIds,
    travelSequencePayLoad: SequencePayload | undefined,
  ) => {
    if (!travelSequencePayLoad) return;
    return apiPostRequest<{ travelProposal: TravelProposal }>(
      `travel/${travelId}/${sequenceSlugByType[travelSequenceType]}`,
      {
        ...travelSequencePayLoad,
      },
    );
  },

  updateSequence: (
    travelId: number,
    travelSequenceType: SequenceTypesIds,
    travelSequencePayLoad: SequencePayload | undefined,
    travelSequenceId: number,
  ) => {
    if (!travelSequencePayLoad) return;
    return apiPutRequest<{ travelProposal: TravelProposal }>(
      `travel/${travelId}/${sequenceSlugByType[travelSequenceType]}/${travelSequenceId}`,
      {
        ...travelSequencePayLoad,
      },
    );
  },

  reorderSequence: (travelId: number, travelSequenceId: number, order: number) => {
    return apiPutRequest<{ travelProposal: TravelProposal }>(
      `travel/${travelId}/sequence/${travelSequenceId}/position`,
      {
        newPosition: order,
      },
    );
  },

  deleteSequence: (travelId: number, travelSequenceId: number) => {
    return apiDeleteRequest<{ travelProposal: TravelProposal }>(
      `travel/${travelId}/sequence/${travelSequenceId}`,
    );
  },
};
